module.exports = __webpack_public_path__ + "img/screend-white-full.f812c869.png";